// extracted by mini-css-extract-plugin
export default {"wrapper":"DesktopLayout_wrapper__+lNP7"};